import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-files-dialog-previewer',
  templateUrl: './files-dialog-previewer.component.html',
  styleUrls: ['./files-dialog-previewer.component.scss']
})
export class FilesDialogPreviewerComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<FilesDialogPreviewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) { }

  ngOnInit(): void {
  }

  closed(): void {
    this.dialogRef.close();
  }

}
